import { IconButton, makeStyles, Typography } from '@material-ui/core'
import ClearIcon from '@material-ui/icons/Clear'
import { LeafletMouseEvent } from 'leaflet'
import React, { FunctionComponent } from 'react'
import { useAppSelector } from 'src/redux/createAdminStore'
import { selectDefinitions } from 'src/redux/definitions/definitions.selectors'
import { IInputProps } from 'src/types'
import { ICoordinate } from '@obvious.tech/constellation'
import Map from '../Map/Map'
import Marker from '../Map/Marker'
import CustomObjectInput from './ObjectInput'

const useStyles = makeStyles({
  flex: {
    display: 'flex',
  },
  coordinateInputs: {
    margin: 8,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  fullfill: {},
})

const CoordinatesInput: FunctionComponent<IInputProps<ICoordinate>> = ({
  value,
  onChange,
  name,
  property,
  record,
  classes,
  ...rest
}) => {
  const objects = useAppSelector(state => selectDefinitions(state).objects)
  const ownClasses = useStyles()

  const { latitude, longitude, altitude } = value ?? {}

  const handleCoordinateSelection = (e: LeafletMouseEvent): void => {
    const { lat, lng } = e.latlng
    onChange({
      latitude: lat,
      longitude: lng,
      altitude: altitude ?? 0,
    })
  }

  return (
    <div className={classes}>
      <Typography variant='body1'>{property.displayedName ?? name}</Typography>
      <div className={ownClasses.flex}>
        <div
          style={{
            height: 300,
            width: 500,
          }}
        >
          <Map
            center={{
              lat: latitude ?? 0,
              lng: longitude ?? 0,
            }}
            // length={4}
            onclick={handleCoordinateSelection}
            zoom={14}
            style={{
              height: '300px',
              width: '500px',
            }}
          >
            {typeof value?.latitude === 'number' &&
            !isNaN(value.latitude) &&
            typeof value?.longitude === 'number' &&
            !isNaN(value.longitude) &&
            (value?.latitude !== 0 || value.longitude !== 0) ? (
              <Marker coordinates={value} />
            ) : null}
          </Map>
        </div>
        <div className={ownClasses.coordinateInputs}>
          <div className={ownClasses.fullfill}>
            <IconButton
              aria-label='clear'
              color='primary'
              onClick={() => {
                onChange(record?.[name])
              }}
            >
              <ClearIcon />
            </IconButton>
          </div>
          <CustomObjectInput<ICoordinate>
            value={value}
            onChange={onChange}
            // @ts-ignore
            property={objects.Coordinate}
            name='coordinates'
          />
        </div>
      </div>
    </div>
  )
}

export default CoordinatesInput
